import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormQualification } from 'system/pages/qualifications/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersQualificationProps {
  filterQualificationForm: FormikProps<FiltersFormQualification>;
}

const FiltersQualification = ({
  filterQualificationForm,
}: FiltersQualificationProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-qualifications-content"
        id="panel-qualifications-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterQualificationForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Codice qualifica"
                label="Codice"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filterQualificationForm.values.code}
                onChange={filterQualificationForm.handleChange}
                error={
                  filterQualificationForm.touched.code &&
                  Boolean(filterQualificationForm.errors.code)
                }
                helperText={filterQualificationForm.errors.code}
                inputProps={{ maxLength: 2 }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Descrizione qualifica"
                label="Descrizione"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterQualificationForm.values.description}
                onChange={filterQualificationForm.handleChange}
                error={
                  filterQualificationForm.touched.description &&
                  Boolean(filterQualificationForm.errors.description)
                }
                helperText={filterQualificationForm.errors.description}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterQualificationForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersQualification.displayName = 'Filters Qualification component';

export default FiltersQualification;
